module.exports = flarum.core.compat['components/CommentPost'];